import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// NOTE ON CHANGE DETECTION (why every @Component declares a strategy):
// Angular 22 flipped the default — `OnPush` is now the default strategy and
// the old v14 "check always" behavior is the opt-in `ChangeDetectionStrategy
// .Eager`. After the migration every component silently became OnPush, so
// anything updated outside a template event binding (Firestore snapshots,
// promises, timers, service subjects) never repainted. Components therefore
// declare `changeDetection: ChangeDetectionStrategy.Eager` explicitly; the
// zone itself is provided by provideZoneChangeDetection() in app.module.
// New components must declare Eager too, or they will not auto-refresh.
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
